export default __webpack_public_path__ + "static/media/studio-2.b78c42a0.jpg";